
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface Props {
    children: JSX.Element;
    allowAdmin?: boolean;
    allowManager?: boolean;
}

const ProtectedRoute: React.FC<Props> = ({
    children,
    allowAdmin,
    allowManager
}) => {
    const { isAdmin, isManager } = useAuth();
    const location = useLocation();

    // Always allow /my-activity for all users
    if (location.pathname === "/my-activity") {
        return children;
    }

    // Admin can access any route
    if (allowAdmin && isAdmin) {
        return children;
    }

    // Manager can access manager routes
    if (allowManager && isManager) {
        return children;
    }

    // If not authorized, redirect to /my-activity
    return <Navigate to="/my-activity" replace />;
};

export default ProtectedRoute;